<template>
  <div>
    <div class="block_5 flex-col">
          <span class="paragraph_1">
            &ensp;&ensp;&ensp;&ensp;公司自有文化传媒、管理顾问，商业运营、景观工程等4大核心竞争力服务经验优势，具备自主产业链服务支撑能力。依托公司强大的产业领域覆盖能力，多元链接商业、品牌、文化、科技、艺术、渠道等服务领域合作伙伴，现有合作商业品牌200+，具有多年运营操盘经验。
          </span>
      <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="../assets/img/img5.webp"
      />
    </div>
    <div class="block_6 flex-col">
          <span class="paragraph_2">
            &ensp;&ensp;&ensp;&ensp;坚持以人为本的服务宗旨，围绕师生群体身心、生活需求，提供及时、高效、专业、贴心、满意的专业服务。公司专业管理人才队伍，构建校园商业体标准体系，规范业态经营风气，杜绝恶意竞争。科学布局分布，全面把控，扩建品牌库，培育校园服务优秀品牌，提升校园商业管理的服务质量和水平，争当校园后動服务的助推器稳定学校市场的定盘星，校园优质服务保障的压舱石。
          </span>
      <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="../assets/img/img6.webp"
      />
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        constants: {}
      };
    },
    methods: {}
  };
</script>
<style scoped lang="css" src="../assets/index.css" />
